import styled from "styled-components";

const Container = styled.div`
  z-index: auto;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 33%;
  left: 25%;
  background-color: ${(props) => props.theme.colors.white};
  border: ${(props) => props.theme.border};
  border-radius: 8px;
  padding: 25px;
  width: 500px;
`;

const ContentContainer = styled.div`
width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
`;

const Label = styled.div`
  margin-top: 16px;
  margin-bottom: 8px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 25px;
  > * {
    &:last-child{
      margin-left: 16px;
    }
  }
`;

export { Container, ButtonContainer, ContentContainer, Label };
